import { Redirect, Route, RouteChildrenProps, Switch } from 'react-router';
import { TransitionGroup } from 'react-transition-group';
import { Queue } from '@rossum/api-client/queues';
import { PageLayout } from '@rossum/components/page-layout/PageLayout';
import { Fade } from '@rossum/ui/material';
import { useSchema } from '../../../business/schema/useSchema';
import { FieldsToCaptureRedesignSurvey } from '../../surveys/FieldsSurveys/FieldsToCaptureRedesignSurvey';
import { FieldPage, FieldsPage } from '../fields';
import { FieldsHeader } from '../fields/components/FieldsHeader';
import { FieldsListSkeleton } from '../fields/components/FieldsListSkeleton';
import { FieldFormSkeleton } from '../fields/components/form/FieldFormSkeleton';
import { QueueSettingsRouteParams } from '../fields/types';

type FieldsRouteProps = RouteChildrenProps<QueueSettingsRouteParams> & {
  queue: Queue;
  workspaceName: string;
};

export const FieldsRoute = ({
  match,
  location,
  queue,
  workspaceName,
}: FieldsRouteProps) => {
  const {
    data: schema,
    isLoading: schemaIsLoading,
    isFetching: schemaIsFetching,
  } = useSchema(queue?.schema);

  if (!match) {
    return null;
  }

  return (
    <PageLayout
      renderHeader={params => (
        <FieldsHeader
          {...params}
          schema={schema}
          schemaIsLoading={schemaIsLoading}
          queue={queue}
          workspaceName={workspaceName}
          match={match}
        />
      )}
    >
      <TransitionGroup>
        <Fade key={location.pathname} appear unmountOnExit>
          <div>
            <Switch location={location}>
              <Route path={`${match.path}/fields`} exact>
                {/* TODO: The inferred type here is wrong, maybe a newer version of router fixed it? */}
                {routeChildrenProps =>
                  schemaIsLoading || !schema ? (
                    <FieldsListSkeleton />
                  ) : (
                    <FieldsPage
                      {...routeChildrenProps}
                      schema={schema}
                      schemaIsFetching={schemaIsFetching}
                    />
                  )
                }
              </Route>
              <Route
                path={`${match.path}/fields/:sectionId?/:schemaItemId?/:schemaItemChildId?`}
                exact
              >
                {routeChildrenProps =>
                  schemaIsLoading || !schema ? (
                    <FieldFormSkeleton />
                  ) : (
                    <FieldPage
                      {...routeChildrenProps}
                      schema={schema}
                      queue={queue}
                    />
                  )
                }
              </Route>
              <Route path={`${match.path}`}>
                <Redirect
                  to={{
                    pathname: `${match.url}/fields`,
                    state: location.state,
                  }}
                />
              </Route>
            </Switch>
          </div>
        </Fade>
      </TransitionGroup>
      <FieldsToCaptureRedesignSurvey />
    </PageLayout>
  );
};
